import { TBudgetType } from '../interfaces/IFilters';
import { TBenefit, ISOLCarOffer } from '../interfaces/Car';

export const transformBenefits = (
    offerBenefits: TBenefit[] | Record<number, TBenefit> | Record<TBudgetType, TBenefit[]>,
    paymentJourneyType: TBudgetType = 'cash'
): TBenefit[] => {
    if (Array.isArray(offerBenefits)) {
        // just array of benefits
        return offerBenefits;
    } else if (paymentJourneyType in offerBenefits) {
        // keyed by journey
        const journeyBenefits = (offerBenefits as Record<TBudgetType, TBenefit[]>)[paymentJourneyType];
        if (Array.isArray(journeyBenefits)) {
            return journeyBenefits;
        } else {
            // badly formatted array as object with int keys - fallback
            return Object.values(journeyBenefits);
        }
    } else {
        // badly formatted array as object with int keys - fallback
        return Object.values(offerBenefits);
    }
};

export const getBenefitsFromOffers = (offers: ISOLCarOffer[], paymentJourneyType: TBudgetType = 'cash'): TBenefit[] => {
    const offerBenefits = offers.find(offer => offer.benefits)?.benefits ?? [];
    return transformBenefits(offerBenefits, paymentJourneyType);
};
